"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var react_1 = __importStar(require("react"));
var SearchVacanciesContext_1 = __importDefault(require("../context/SearchVacanciesContext"));
var SearchBarContainer_1 = __importDefault(require("../search/SearchBarContainer"));
var VacanciesPage_1 = __importDefault(require("./VacanciesPage"));
var VacanciesPageContainer = function () {
    var _a = (0, react_1.useContext)(SearchVacanciesContext_1.default), vacancies = _a.vacancies, updateQuery = _a.updateQuery;
    (0, react_1.useEffect)(function () {
        updateQuery({});
    }, []);
    var handlePageChange = (0, react_1.useCallback)(function (page) {
        updateQuery({ page: page });
    }, [updateQuery]);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(SearchBarContainer_1.default, {}), (0, jsx_runtime_1.jsx)(VacanciesPage_1.default, { vacancies: vacancies, onPageChange: handlePageChange })] }));
};
exports.default = VacanciesPageContainer;
